import React from "react";
import { css } from "emotion";
import { boxStyles } from "../../styles/theme";
import logo from "../../assets/logo-dark.svg";
import MenuButton from "./MenuButton";

const TopRow = ({ isSettings }) => {
  return (
    <div className={container}>
      <img src={logo} alt="Spotlight's Company Logo" />
      <MenuButton isSettings={isSettings} />
    </div>
  );
};

export default TopRow;

const container = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 12px 12px 12px;
  overflow: visible;

  img {
    max-height: 34px;
  }
`;
